import type { Screen } from '@/types';

export enum RightPanelTab {
  Presets = 'presets',
  Creations = 'creations',
}

export type AppExperience = 'create' | 'landing';

export interface NavigationSlice {
  screen: Screen;
  previousScreen: Screen | null;
  setScreen: (screen: Screen) => void;
  rightPanelTab: RightPanelTab;
  setRightPanelTab: (tab: RightPanelTab) => void;
  appExperience: AppExperience;
}
